module.exports = "/_next/static/images/93d13637044f9f00879d5a1b54eebb60-young-people-walking@3x.jpg.webp";